import type { TrackUpgradeFunnelEventDto, UpgradeFunnelBrowserEvent } from '@shared/core/analytics'
import { useCallback } from 'react'
import { useMutation } from 'react-query'
import type { UpgradeFunnelEventProperties } from 'src/modules/payment/types/upgrade-funnel.types'
import { ApiService } from 'src/services/api.service'

export const TRACK_UPGRADE_FUNNEL_MUTATION_KEY = 'track-upgrade-funnel'

export type TrackUpgradeFunnelEventOptions = {
  onSuccess?: () => void
}

export type TrackUpgradeFunnelEvent = <E extends UpgradeFunnelBrowserEvent>(
  eventType: E,
  properties: UpgradeFunnelEventProperties[E],
  options?: TrackUpgradeFunnelEventOptions,
) => void

export function useTrackUpgradeFunnel(): TrackUpgradeFunnelEvent {
  const { mutate } = useMutation(TRACK_UPGRADE_FUNNEL_MUTATION_KEY, (body: TrackUpgradeFunnelEventDto) =>
    ApiService.Analytics.trackUpgradeFunnel(body),
  )

  // `mutate` (not `mutateAsync`) swallows request errors, so tracking never throws into the surface.
  // A caller that must know the event landed passes `onSuccess`, which only runs on a 2xx.
  return useCallback<TrackUpgradeFunnelEvent>(
    (eventType, properties, options) =>
      mutate({ event_type: eventType, event_properties: { ...properties } }, { onSuccess: options?.onSuccess }),
    [mutate],
  )
}
